<script>
import { AisPagination } from 'vue-instantsearch/vue3/es';

export default {
  name: 'AgoliaPagination',

  components: {
    AisPagination,
  },

  props: {
    showPagination: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onPageChange(page) {
      const currentPage = new URL(window.location.href).searchParams.get('page');
      // algolia pagination is 0-indexed, URL page is 1-indexed
      const newPage = page + 1;

      // Only scroll if the page actually changed
      if (newPage !== Number(currentPage)) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>

<template>
  <ais-pagination
    v-show="showPagination"
    :padding="3"
    @page-change="onPageChange"
  />
</template>

<style lang="scss">
  /*
    Algolia Style overrides
  */

  .ais-Pagination {
    padding-bottom: 2rem;

    &-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 4rem 2rem 0;
      margin: 0 auto;
      max-width: 800px;
    }

    &-item {
      list-style: none;
      margin: 0.5rem;
      border: solid 1px $color-black;
      color: $color-black;

      a,
      span {
        display: block;
        padding: 0.5rem 0.75rem;

        &:link,
        &:active,
        &:hover,
        &:focus {
          color: $color-black;
          background: transparent;
          text-decoration: none;
          @include font-primary();
          transition: all 0.2s ease;
        }

        &:hover {
          background: $color-black;
          color: $color-white;
        }
      }
    }

    &-item--selected {
      background: $color-black;

      a {
        color: $color-white;

        &:link,
        &:active,
        &:hover,
        &:focus {
          color: $color-white;
        }
      }
    }
  }
</style>
